import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button';
import { HTMLAttributeAnchorTarget } from 'react';

import { getUnitActionsLink } from './linkUtils';

export interface LegacyButtonProps
	extends Pick<
		ButtonProps,
		'variant' | 'color' | 'size' | 'sx' | 'disabled' | 'endIcon'
	> {
	label: string;
	mvcAction: string;
	target?: HTMLAttributeAnchorTarget;
	unitId: number;
	additionalParams?: Record<string, string>;
}

export const LegacyButton = ({
	color = 'secondary',
	disabled = false,
	mvcAction,
	label,
	size = 'large',
	sx = {
		mt: 2,
	},
	target = '_self',
	unitId,
	variant = 'contained',
	additionalParams,
	...props
}: LegacyButtonProps) => (
	<Button
		disabled={disabled}
		color={color}
		href={getUnitActionsLink(mvcAction, unitId, additionalParams)}
		size={size}
		sx={sx}
		target={target}
		variant={variant}
		{...props}>
		{label}
	</Button>
);
